module.exports = __webpack_public_path__ + "img/bg-book-1.f9a290c5.png";